import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router';

import IssueForm from './IssueForm';
import LoadMask from '../../../../Utils/LoadMask/LoadMask';
import useUpdate from '../../../../../hooks/useUpdate';
import LoaderContext from '../../../../../context/LoaderContext';
import MovmentContext from '../../../../../context/MovmentContext';
import { NotificationManager } from 'react-notifications';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

import './DetailTable.css';
import useCreate from '../../../../../hooks/useCreate';
import PrintFormat from '../../Utils/PrintFormat';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import MissingProductsContext from '../../../../../context/MissingProductsContext';

import IssueLogo from '../../../../../../../assets/img/salida-logo.svg';
import TitleIcon from '../../Utils/TitleIcon';

const CreateUpdate = ({ path_back }) => {
    const location = useLocation();
    const isViewed = location.pathname.includes('view');

    // radio button state (movment)
    // 1 product
    // 2 school kit
    const { movment } = useContext(MovmentContext);
    const isProduct = movment === 1;

    const { data, title, update, updateData } = useUpdate(
        'inventory_issue',
        path_back
    );
    const { saveData: saveIssue } = useCreate(
        'inventory_issue',
        '/inventory/inventory_issue'
    );
    const { loader } = useContext(LoaderContext);

    const [issues, setIssues] = useState([]);

    const makeRandomId = () => {
        let a = new Date();
        let b = a.toISOString();
        let id = b.replace(/[-T:.Z]/g, '');
        return id;
    };

    const saveData = () => {
        if (issues.length < 1) {
            // no product added
            NotificationManager.error(
                'Agrega al menos 1 Artículo',
                'ERROR',
                6000
            );
        } else {
            // Formatting the data to a format acceptable to the issue api
            const details = []; /// array with the formatted products
            issues.map((product_issue) => {
                const {
                    sub_location,
                    product,
                    serial_number,
                    observations,
                    location,
                    quantity,
                } = product_issue;
                const serie =
                    serial_number === 'NO_SERIAL' ? '' : serial_number;

                const isKit = product_issue.product.school_kit; // true false
                // If it is a kit, separate the products and format the data
                if (isKit) {
                    const kit_products = product_issue.product.school_kit;
                    const school_kit = product_issue.product.id;
                    kit_products.map((kit_product) => {
                        const total_quantity = quantity * kit_product.quantity;
                        // Total products to output
                        details.push({
                            sub_location,
                            product: kit_product.product.id,
                            serial_number: serie,
                            observations,
                            location: location.id,
                            school_kit,
                            quantity: parseInt(total_quantity),
                        });
                    });
                } else {
                    const school_kit = '';
                    // format the data
                    details.push({
                        sub_location,
                        product: product.product,
                        serial_number: serie,
                        observations,
                        location: location.id,
                        school_kit,
                        quantity: parseInt(quantity),
                    });
                }
            });
            // Acceptable data format for the api
            const date_issue = dayjs(issues[0].date).format(
                'YYYY-MM-DD HH:mm:ss'
            );
            const origin = issues[0].location.id;
            const formatData = {
                type: 'salida',
                date: date_issue,
                origin,
                details,
            };

            // send data to api
            Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'Al guardar la salida, afectara a inventario',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    saveIssue(formatData);
                }
            });
        }
    };

    const onSubmit = (dataForm, event) => {
        const body = { ...dataForm };
        event.reset({
            location: body.location,
            date: body.date,
            quantity: '1',
        });
        if (!update) {
            if (isProduct) {
                body.description = body.product.description;
            } else {
                body.description = body.product.name;
            }
            body.location_name = body.location.name;
            body.sub_location =body.product.sub_location || '';
            body.serial_number = body.product.serial_number || '';
            body.observations = '';
            body.id = makeRandomId();
            setIssues([...issues, body]);
        } else {
            if (body.assigned_to) body.assigned_to = body.assigned_to.id;
            body.product = body.product.id;
            updateData(body);
        }
    };

    // global context, to get the missing products (the state is set in useCreate)
    const { missingProducts } = useContext(MissingProductsContext);
    return (
        <React.Fragment>
            {/* button to download pdf (hidden)
            download by reference id (element.click()) */}
            <PDFDownloadLink
                document={<PrintFormat data={missingProducts} />}
                fileName="artículos-faltantes.pdf"
                style={{ display: 'none' }}
            >
                <button id="download-pdf">
                    Descargar PDF
                    <span style={{ display: 'none' }}>
                        {!missingProducts.length}
                    </span>
                </button>
            </PDFDownloadLink>
            {/* <PDFViewer style={{ width: '100%', height: '90vh' }}>
                <PrintFormat data={missingProducts} />
            </PDFViewer> */}
            <LoadMask loading={loader} blur>
                <div>
                    <TitleIcon title="Salidas" image={IssueLogo} />
                    <IssueForm
                        issueData={data}
                        onSubmit={onSubmit}
                        update={update}
                        path_back={path_back}
                        isViewed={isViewed}
                        issues={issues}
                        setIssues={setIssues}
                        onClick={saveData}
                    />
                </div>
            </LoadMask>
            <br />
        </React.Fragment>
    );
};

export default CreateUpdate;
